export default __webpack_public_path__ + "static/media/sign-in_8.aa15e681.jpg";